(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8126],{

/***/ 35579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _modules_study_explore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1961);
/* harmony import */ var _modules_study_explore_components_banner_box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20155);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81496);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);







var ExploreUniList = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 44138));
}, {
  loading: function loading() {
    return "Loading...";
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(44138)];
    }
  }
});

var University = function University(_ref) {
  var topUniData = _ref.topUniData,
      country_slug = _ref.country_slug;
  var countryInfo = topUniData.countryInfo,
      dataResult = topUniData.dataResult;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_3__/* .LayoutMain */ .Ku, {
    title: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.metaTitle,
    metaTitle: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.metaTitle,
    metaDescription: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.metaDescription,
    metaImage: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.src,
    metaUrl: "".concat("https://myunisearch.com", "/").concat(country_slug, "/university"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_explore__WEBPACK_IMPORTED_MODULE_0__/* .ExploreBanner */ .rg, {
      title: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.metaTitle,
      description: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.metaDescription
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      style: styles.unilistWrapper,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_explore_components_banner_box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        image: (countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.src) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
        alt: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.name,
        title: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.name,
        university: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.totalUni,
        courses: countryInfo === null || countryInfo === void 0 ? void 0 : countryInfo.totalCourse
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ExploreUniList, {
      topUniData: dataResult
    })]
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (University);
var styles = {
  unilistWrapper: {
    maxWidth: "1920px",
    marginLeft: "auto",
    marginRight: "auto",
    paddingLeft: "30px",
    paddingRight: "30px"
  }
};

/***/ }),

/***/ 89010:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country_slug]/university",
      function () {
        return __webpack_require__(35579);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5445,5937,2013,4617,955,9866,3874,6556,7662,2884,8719,8322,5824,3480,5551,5260,1496,5603,1656,944,8480,9774,2888,179], function() { return __webpack_exec__(89010); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);